import {Loader, Post} from '$shared/components';
import {Button, Placeholder} from '$uikit';
import {classNames} from '$utils';
import React from 'react';
import {useTranslator} from '$hooks';
import {ExploreItemsInterface} from 'core/Explore/ExploreItems/ExploreItems.interface';

const ExploreItemsComponent = ({isLoading, isFailed, handleRetry, posts, tagsPrepared, handleTag, selected}: ExploreItemsInterface) => {
    const t = useTranslator();

    if (isLoading && posts.length === 0) {
        return <Loader isWrapped/>
    }

    if (isFailed) {
        return (
            <Placeholder
                title={t('failed_title')}
                actions={<Button size="small" onClick={handleRetry}>{t('failed_button')}</Button>}
            >
                {t('failed_caption')}
            </Placeholder>
        );
    }

    return (
        <>
            <div className="Explore__tags">
                {tagsPrepared.map((tag) => (
                    <div
                        key={tag.name}
                        onClick={() => handleTag(tag.name)}
                        className={classNames({
                            Explore__tag: true,
                            active: selected === tag.name || tag.name === 'all' && !selected,
                        })}
                    >
                        <div className="Explore__tag__name">{tag.name === 'all' ? 'Все' : `#${tag.name}`}</div>
                        {tag.name !== 'all' && <div className="Explore__tag__count">{tag.count}</div>}
                    </div>
                ))}
            </div>
            {isLoading ? (
                <Placeholder>
                    <Loader />
                </Placeholder>
            ) : posts.map((postId) => <Post key={postId} postId={postId} />)}
        </>
    );
}

export const ExploreItems = React.memo(ExploreItemsComponent);